export default __webpack_public_path__ + "static/CenturyGothic-Bold-de74dfe5e97b861ec3956d7add46ef21.ttf";